module.exports = __webpack_public_path__ + "img/A58A1027_min.2618faee.jpg";